import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

const openDialogRefs = new Set<DynamicDialogRef<unknown>>();
let trackingInstalled = false;

export function resetOpenDynamicDialogTrackingForTests(): void {
	trackingInstalled = false;
	openDialogRefs.clear();
}

@Injectable({
	providedIn: 'root',
})
export class OpenDynamicDialogs {
	constructor(@Inject(DOCUMENT) private document: Document) {
		this.installTracking();
	}

	closeAll(): void {
		for (const ref of [...openDialogRefs]) {
			try {
				ref.close();
			} catch (error) {
				console.error(error);
			}
			try {
				ref.destroy();
			} catch (error) {
				console.error(error);
			}
		}
		openDialogRefs.clear();
		this.document.body?.classList.remove('p-overflow-hidden');
	}

	private installTracking(): void {
		if (trackingInstalled) {
			return;
		}
		trackingInstalled = true;
		const originalOpen = DialogService.prototype.open;
		DialogService.prototype.open = function <T>(
			this: DialogService,
			componentType: Type<T>,
			config: DynamicDialogConfig,
		): DynamicDialogRef<T> {
			const ref = originalOpen.call(this, componentType, config);
			if (ref) {
				openDialogRefs.add(ref);
				const subscription = ref.onDestroy.subscribe(() => {
					openDialogRefs.delete(ref);
					subscription.unsubscribe();
				});
			}
			return ref;
		};
	}
}
